/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ITokenWrapper, ITokenWrapperInterface } from "../ITokenWrapper";

const _abi = [
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ITokenWrapper__factory {
  static readonly abi = _abi;
  static createInterface(): ITokenWrapperInterface {
    return new utils.Interface(_abi) as ITokenWrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITokenWrapper {
    return new Contract(address, _abi, signerOrProvider) as ITokenWrapper;
  }
}
